// extracted by mini-css-extract-plugin
module.exports = {"header":"StandardHeader-module--header--34NW1","homepageLink":"StandardHeader-module--homepageLink--p1Lzo"};